<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <div class="quiz-options-section">
      <div class="mb-2">
        {{ $i18nPresenter.t('Response') }}
      </div>
      <div class="grid gap-y-2">
        <slot name="responses">
          <ResponseItem
            :option="notAnsweredOption"
            :showCheckMarkIcon="false"
          />
        </slot>
      </div>
    </div>
    <div>
      <div class="quiz-options-section">
        <div class="mb-2 flex gap-1 font-bold text-green-100">
          {{ $i18nPresenter.t('Correct answer') }}
        </div>
        <div class="grid gap-y-2">
          <slot name="answers">
          </slot>
        </div>
      </div>
      <div class="quiz-options-section mt-2" v-if="$slots.otherCorrect">
        <div class="mb-2">
          {{ $i18nPresenter.t('Also accepted') }}:
        </div>
        <div class="grid gap-y-2">
          <slot name="otherCorrect"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResponseItem from '@/components-v2/presentation-report/ReportAudienceDetail/closed-question/ResponseItem.vue'

export default {
  components: {
    ResponseItem,
  },
  props: {
    dataAnswer: {
      type: Object,
      default: () => {
      },
    },
  },
  computed: {
    notAnsweredOption() {
      return {
        title: '-',
      }
    },
  },
}
</script>
